import { render, staticRenderFns } from "./_cv-feedback-button.vue?vue&type=template&id=3be8414a&"
import script from "./_cv-feedback-button.vue?vue&type=script&lang=js&"
export * from "./_cv-feedback-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports